/**
 * Auth store (Zustand).
 *
 * PROMPT 06: tokens (JWT access + refresh) ficam em cookies httpOnly no browser.
 * O JS NUNCA acessa os tokens — eles são enviados automaticamente pelo browser
 * em toda request via `credentials: 'include'` (ver lib/api.ts).
 *
 * Aqui guardamos APENAS o user (dados públicos). Quando o user dá F5, o cookie
 * persiste, mas como não temos o user em memória, precisamos revalidar com o
 * back-end. Por ora, o F5 dispara redirect pro /login (o cookie continua,
 * mas o user não é re-fetched). Próxima iteração: adicionar endpoint /me
 * que valida o cookie e retorna o user.
 */
import { create } from 'zustand';
import type { User } from '@/types/api';

interface AuthState {
  user: User | null;

  setUser: (user: User) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,

  setUser: (user) => set({ user }),

  clear: () => set({ user: null }),
}));

export const isAuthenticated = (s: AuthState) => !!s.user;
